import UsersPage from 'pages/Users/Users'
import UserPreview from 'pages/Users/UserPreview'
import UserEditPage from 'pages/Users/UserEdit'
import UserCreationPage from 'pages/Users/UserCreate'
import { redirect, RouteObject } from 'react-router-dom'
import axios from 'axios'
import { base_url } from 'env'
import SurveyEditPage from 'pages/Users/SurveyEdit'
import SurveyCreatePage from 'pages/Users/SurveyCreate'
import SubscriptionAssignPage from 'pages/Users/SubscriptionAssign'
import LicenseAssignPage from 'pages/Users/LicenseAssign'
import UserPasswordEditPage from 'pages/Users/UserPasswordEdit' // <-- NEW: Import the password page

export const UserRoutes: RouteObject[] = [
  {
    path: 'users',
    loader: async () => {
      try {
        const response = await axios.get(base_url + '/user/')
        return response.data
      } catch (error) {
        console.log(error)
        return []
      }
    },
    element: <UsersPage />,
  },
  {
    path: 'user',
    element: <UserCreationPage />,
  },
  {
    path: 'user/:login',
    loader: async ({ params }) => {
      try {
        const response = await axios.get(base_url + `/user/${params.login}`)
        return response.data
      } catch (error) {
        console.log(error)
        return redirect('/users')
      }
    },
    element: <UserPreview />,
  },
  {
    path: 'user/:login/edit',
    loader: async ({ params }) => {
      try {
        const response = await axios.get(base_url + `/user/${params.login}`)
        return response.data
      } catch (error) {
        console.log(error)
        return redirect(`/user/${params.login}`)
      }
    },
    element: <UserEditPage />,
  },
  {
    path: 'user/:login/password/edit',
    element: <UserPasswordEditPage />,
  },
  {
    path: 'user/:login/survey/edit',
    loader: async ({ params }) => {
      try {
        const response = await axios.get(
          `${base_url}/user/${params.login}/survey`
        )
        return response.data
      } catch (error) {
        console.error('Failed to load survey for editing:', error)
        return redirect(`/user/${params.login}`)
      }
    },
    element: <SurveyEditPage />,
  },
  {
    path: 'user/:login/survey/create',
    element: <SurveyCreatePage />,
  },
  {
    path: 'user/:login/subscription/assign',
    element: <SubscriptionAssignPage />,
  },
  {
    path: 'user/:login/license/assign',
    element: <LicenseAssignPage />,
  },
]
